/**
 * Build-time feature toggles (Vite `import.meta.env`).
 * Set in CI via `VITE_FEATURE_*` env vars when building the frontend.
 */
export const isGitLabEnabled = import.meta.env.VITE_FEATURE_GITLAB_ENABLED === 'true';
export const isGiteaEnabled = import.meta.env.VITE_FEATURE_GITEA_ENABLED === 'true';
/** Azure DevOps connect UI (spec 493 A-2b); off shows the "coming soon" card instead. */
export const isAzureDevOpsEnabled = import.meta.env.VITE_FEATURE_AZURE_DEVOPS_ENABLED === 'true';
/**
 * Azure Boards work-item import (spec 493 D1); off (unset) hides the import section, the per-project
 * import line and their copy: Boards items then arrive like Jira / Linear ones (webhook, lazy fetch).
 * Must match backend FEATURE_AZURE_BOARDS_IMPORT_ENABLED.
 */
export const isAzureBoardsImportEnabled =
  import.meta.env.VITE_FEATURE_AZURE_BOARDS_IMPORT_ENABLED === 'true';
